import React, { FC, useEffect, useState } from 'react'
import { CampaignPeriod } from '../../../api/campaingsApi';
import { generateSkinAdhocReport, getSkinAdhocReports, MediaReportRow, ReportAdhocStatus } from '../../../api/reportsApi';
import { convertUTCDateToLocalDate, formatDate, getPastDateByDaysAgo } from '../../../services/dateService';
import { Button } from '../../components/Button';
import GlobalSpinner from '../../components/globalsSpinner/GlobalSpinner';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import InnerLayout from '../innerLayout/InnerLayout';

export interface ReportPageProps  extends RouteComponentProps<any>
{
    logOut : () => void;
    toogleCollapse: () => void;
    isCollapsed: boolean;
}

const MosaicAdhocReport:FC<ReportPageProps> = (props) => {
    let {logOut, toogleCollapse, isCollapsed} = props;

    let [skinAdhocReports, setSkinAdhocReports] = useState<MediaReportRow[]>([]);
    let [reportDateStart, setReportDateStart] = useState('');
    let [isPeriodStartError, setIsPeriodStartError] = useState(false);
    let [reportDateEnd, setReportDateEnd] = useState('');
    let [isPeriodEndError, setIsPeriodEndError] = useState(false);
    let [isLoading, setIsLoading] = useState(false);
    let [minDateReport, setMinDateReport] = useState(getPastDateByDaysAgo(360));

    useEffect(()=>{
        async function fetchReportList(){
            setIsLoading(true);
            await Promise.all([updateReportList()])
            setIsLoading(false);
        }

        fetchReportList();
    },[])

    async function updateReportList(){
        let skinAdhocReport = await getSkinAdhocReports();
        if( skinAdhocReport.type === "succes"){
            setSkinAdhocReports(skinAdhocReport.data.items);
        }
    }

    const setStartDatePeriod = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsPeriodStartError(false);
        setReportDateStart(event.target.value);
    }

    const setEndDatePeriod = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsPeriodEndError(false); 
        setReportDateEnd(event.target.value)
    }

    const generateReport = async () => {
        if(!!!reportDateStart){
            setIsPeriodStartError(true);
            return
        }

        if(!!!reportDateEnd){
            setIsPeriodEndError(true);
            return
        }

        let period = {
            startDateTime: reportDateStart,
            endDateTime: reportDateEnd
        }

        setIsLoading(true);
        await generateSkinAdhocReport(period);

        let skinAdhocReport = await getSkinAdhocReports();
        if( skinAdhocReport.type === "succes"){
            setSkinAdhocReports(skinAdhocReport.data.items);
        }
        setIsLoading(false);
    }   

    const renderStatusAdhoc = (status: ReportAdhocStatus) => {
        switch(status){
            case ReportAdhocStatus.Generated : return <span className="status-active">Generated</span>;
            case ReportAdhocStatus.InProgress : return <span className="status-draft">In progress</span>;
            case ReportAdhocStatus.Requested : return <span className="status-paused">Requested</span>;
        }  
    }

    const renderPeriod = (period: CampaignPeriod) => {
        return <p>{formatDate(period.startDate)} - {formatDate(period.endDate)}</p>
    } 

    const renderSkinAdhocReportRow = (mosaicAdhocReports: MediaReportRow[]) => {
        return mosaicAdhocReports.map( (it, i) => {
            return <tr key={i}>
                <td>{convertUTCDateToLocalDate(it.dateRequested)}</td>
                <td>{renderStatusAdhoc(it.status)}</td>
                <td>{renderPeriod({startDate: it.startDateTime, endDate: it.endDateTime})}</td>
                <td>{it.status !== ReportAdhocStatus.Generated ? "" :  <a href={`${it.downloadUrl}`} download>Download</a>} </td>
            </tr>
        })
    }

    return (
        <InnerLayout 
            activeTab="reports" 
            logOut={logOut} 
            toogleCollapse={toogleCollapse} 
            isCollapsed={isCollapsed}
        >
            <>
                <div className="search-media-report-block">
                    <div className="form-row">
                        <label htmlFor="start">Starts</label>
                        <input 
                            type="date" 
                            className={`form-control ${isPeriodStartError ? "error" : ""}`}  
                            name="" 
                            id="start" 
                            min={minDateReport}
                            onChange={setStartDatePeriod}
                        />
                        {isPeriodStartError && <span className="error">Please select start period</span>}
                    </div>
                    <div className="form-row">
                        <label htmlFor="start">Ends</label>
                        <input 
                            type="date" 
                            className={`form-control ${isPeriodEndError ? "error" : ""}`}  
                            name="" 
                            id="end" 
                            onChange={setEndDatePeriod}
                            min={reportDateStart}
                        />
                        {isPeriodEndError && <span className="error">Please select end period</span>}
                    </div>
                    <div className="">
                        <label style={{"marginBottom": "4px", "display": "block"}} htmlFor="">&nbsp;</label>
                        <Button color="green" label="Generate" onClick={generateReport}/>
                    </div>
                </div>

                <table className="table report-table">
                    <thead>
                        <tr>
                            <td>Date</td>
                            <td>Status </td>
                            <td>Period</td>
                            <td>Download</td>
                        </tr>
                    </thead>
                    <tbody>
                        {renderSkinAdhocReportRow(skinAdhocReports)}
                    </tbody>
                </table>
                <GlobalSpinner isShow={isLoading} />
            </>
        </InnerLayout>
    )
}

export default withRouter(MosaicAdhocReport)